module.exports = __webpack_public_path__ + "img/icon_instagram_inverse_x.6d169362.svg";